function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "physical_svg__a",
  d: "M13.75 8.177v.539a.75.75 0 11-1.5 0v-.54h-.6a.75.75 0 110-1.5h.6V6a.75.75 0 111.5 0v.677h.615a.75.75 0 010 1.5h-.615zm-7.212-2.55a.75.75 0 01-1.5 0v-.96c0-.686.4-1.308 1.023-1.592L12.4.176a1.75 1.75 0 011.472.008l6.14 2.89a1.75 1.75 0 011.006 1.584v13.58a1.75 1.75 0 01-1.75 1.75H16.22a1.75 1.75 0 01-1.75-1.75v-3.605a.25.25 0 00-.25-.25h-2.437a.75.75 0 010-1.5h2.437c.967 0 1.75.783 1.75 1.75v3.605c0 .138.112.25.25.25h3.049a.25.25 0 00.25-.25V4.658a.25.25 0 00-.144-.226l-6.14-2.89a.25.25 0 00-.21-.002l-6.341 2.9a.25.25 0 00-.147.227v.961zM.972 19.156c.43-3.449 2.5-5.266 5.994-5.266 3.5 0 5.535 1.827 5.877 5.285a.75.75 0 01-.747.824H1.716a.75.75 0 01-.744-.843zm6.062-5.514c-1.84 0-3.338-1.463-3.338-3.276 0-1.814 1.499-3.277 3.338-3.277 1.84 0 3.338 1.463 3.338 3.277 0 1.813-1.498 3.276-3.338 3.276z"
}));
var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#637280",
  transform: "translate(-1)",
  xlinkHref: "#physical_svg__a"
});
function SvgPhysical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysical);
export default __webpack_public_path__ + "static/media/physical.2ba50b83.svg";
export { ForwardRef as ReactComponent };